import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getCourseList(activityId) {
    return httpAdminClient.get(`admin/train/activities/${activityId}/schedules?page=1&per_page=10000`);
  },
  getCourseSignList(scheduleId) {
    return httpAdminClient.get(`/admin/train/schedules/${scheduleId}/attendances`);
  },
  createCourse(activityId, data) {
    return httpAdminClient.post(`admin/train/activities/${activityId}/schedules`, { train_schedule: { ...data } });
  },
  patchCourse(id, data) {
    return httpAdminClient.patch(`admin/train/schedules/${id}`, { train_schedule: { ...data } });
  },
  deleteCourse(id) {
    return httpAdminClient.delete(`admin/train/schedules/${id}`);
  },
  showCourse(id) {
    return httpAdminClient.get(`admin/train/schedules/${id}`);
  },
  showAttend(id) {
    return httpAdminClient.get(`/admin/train/schedules/${id}/attendances`);
  },
  getRegisterUrl(id) {
    return httpAdminClient.get(`/admin/train/activities/${id}/export_attendances`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/train/courseApi.js